import { RegistryService } from './../registry/registry.service';
import { AuthService } from './../user/auth.service';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { PaymentService } from '../payment/payment.service';
import { TrackedGiftCollection } from '../payment/tracked-gift-collection';
import { TrackedGift } from '../payment/tracked-gift';
import { SettingsService } from '../settings/settings.service';
import { Contribution } from "./contribution";
import { Registry } from "../registry/registry";
import { ActivatedRoute, Router } from '@angular/router';
import { Http, RequestOptions, Headers } from '@angular/http';
import { environment } from '../../environments/environment';
import { UserService } from '../user/user.service';
import { Settings } from '../settings/settings';
import { ImageUrlService } from '../shared/services/image-url.service';
import { filter, take, takeUntil, switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument,
  
  
} from 'angularfire2/firestore';
import { MerchantStateStore } from '../merchant/merchant.state.store';


@Component({
  selector: 'app-track',
  templateUrl: './track.component.html',
  styleUrls: ['./track.component.scss']
})
export class TrackComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  loading = false;
  bankDetailsConfirmed = false;
  showBankDetailsModal = false;

  contributions: Contribution[];
  paidContributions: Contribution[];
  pendingContributions: Contribution[];
  contributionGroups: Array<Contribution[]>;
  symbol: string;
  loaded: boolean = false;
  showList: string;
  registry: Registry;
  anonymousCoupleMode = false;
  contributionLimit: Number;
  settings: Settings;
  public registryValue = 0;
  payengineBalance: {
    available: number, 
    pending: number 
  } = undefined;
  public todaysContributions = 0;
  remainingTransfers: number = 3; // Default to 3 transfers
  maxTransfersOverride: number | null = null;
  transfers: Array<{transferId: string, date: number}> = [];
  payouts: any[] ;
  payengineTransfersLoading: boolean = true;
  hasStripecontributions = false;
  balance: any;
  devMode = null
  public totalContributions = 0;
  demoContributions:any =
    {
      "applicationFee": 0,
      "createdDate": new Date(),
      "cart": [
          {
              "gift": {
                  "category": null,
                  "createdDate": 1680999870438,
                  "createdFromGiftAssistant": null,
                  "paidAmount": 400,
                  "views": 0,
                  "cropParams": null,
                  "editing": false,
                  "removing": false,
                  "removingConfirmed": false,
                  "hex": "1",
                  "imageName": "gift_1",
                  "anonGiftId": null,
                  "mustBuyEntireGift": false,
                  campaign: null,
                  portions: null,
                  websiteLinkText: null,
                  "giftTemplateName": null,
                  "source": null,
                  "partnershipId": null,
                  "hideFundingProgress": false,           
                  "description": "After the big day, we'll be jetting away on our adventure of a lifetime.\n",
                  "descriptionTranslation": "",
                  "editedAfterGiftAssistant": null,
                  "featuredGift": null,
                  "friendlyUrl": "Flights",
                  "fromRegistry": "sample-gifts",
                  "fromTemplate": true,
                  "giftTypeSelection": "Experience",
                  "hidePrice": false,
                  "id": "K2DMcGrI0mipVNv8j1Tk",
                  "imageUrl": "https://images.unsplash.com/photo-1496686941088-eaa405ad5fbb",
                  "location": null,
                  "modifiedDate": 1680999870438,
                  "paidPercent": 51,
                  "price": 1000,
                  "pricePerPortion": 0,
                  "registryId": "fuIyeR1a25oYJvWdlL0i",
                  "remaining": 490,
                  "showGiftAmount": null,
                  "showTranslation": true,
                  "status": "active",
                
                  "templateGiftId": "gw8B18dvcDjKSFVCGrNA",
                  "title": "Flights",
                  "titleTranslation": "Le flight",
                  "type": "experience",
                  "userId": "zbmJg1e2eddV679bhlj3ziXT0Uv2",
                  "videoUrl": null,
                  "website": null
              },
              "giftId": "K2DMcGrI0mipVNv8j1Tk",
              "price": 400
          }
      ],
      "chargeTotal": 400,
      "coupleFee": 0,
      "coupleGets": 400,
      "giftTotal": 400,
      "guestEmail": "ifonseka1@gmail.com",
      "guestFee": 0,
      "guestName": "lksdjfdkls",
      "guetsPays": 400,
      "isManualContribution": true,
   
      "manualPaymentMethod": "wise",
      
      "whenWillGuestPay": "now",
      
      "number": 7,
      "id": "wiseifons_1682720973721",
      "friendlyPaymentMethod": "Wise"
  }
  


  contributionCount = {
    bank: 0,
    venmo: 0,
    custom: 0,
    cash: 0,
    revolut: 0,
    cashApp: 0,
    cheque: 0,
    bitcoin: 0,
    paypal: 0,
    stripe: 0,
    zelle: 0,
    wise: 0,
    payId: 0

  }
  cancelledContributions: Contribution[];
  currentPosition: number;
  hideMobileMenu: boolean;
  hasPayEngineContributions: boolean;
  showTransferModal: boolean = false;

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e: Event) {
   
    let scroll = window.pageYOffset || document.documentElement.scrollTop;

    if (scroll > this.currentPosition && (scroll > 2)) {
      this.hideMobileMenu = true;
    } else {
      this.hideMobileMenu = false;
    }

    this.currentPosition = scroll;
    
  }



  constructor(
    private _registryFirebaseService: RegistryFirebaseService,
    private _authService: AuthService,
    private _registryService: RegistryService,
    private _route: ActivatedRoute,
    private _userService: UserService,
    private _paymentService: PaymentService,
    private _http: Http,
    private firestore: AngularFirestore,
    private merchantStateStore: MerchantStateStore,
    private imageUrlService: ImageUrlService
  ) {

    document.title = "Contributions | Hitchd";
    this._authService.user.subscribe(user => {
      if (!user) {
        return;
      }
      if (user != null) {
        this._authService.authToken().subscribe(token => {

          let formValue = {
            token: token,              
          }

        
          const headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
          const options = new RequestOptions({ headers: headers,  });
         
          return this._http.get(environment.firebase.clouldFunctionHost + '/checkPayoutData?token='+token, options)
          .subscribe(response => {
            
            if(response.status == 200){
            const data = response.json();
            this.payouts = data.payouts;
            this.balance = data.balance;
                   return response;
            }
          });
        
        });
      }


      

      this._registryFirebaseService.initGiftsForUser(user);
      this._registryFirebaseService.currentGifts.subscribe(gifts => {
        this._registryFirebaseService.killLoader();
        if (gifts) {

          this.registryValue = gifts.reduce(function (prevVal, elem) {
            if (!elem.hidePrice) {
              return prevVal + elem.price;
            } else {
              return prevVal;
            }
          }, 0);

          this.hasStripecontributions = false;

          this._registryFirebaseService.getContributions(gifts, this.registry).subscribe(contributions => {
        
            if (contributions && this.devMode !== 'demo' ) {
              this.contributions = contributions
                .sort(function (a, b) { return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime(); });

                this.paidContributions = this._registryFirebaseService.getContributionsbyStatus(this.contributions, 'paid');
                

if (this.paidContributions && this.paidContributions.length)
this.paidContributions.forEach(contribution => {
  if (contribution.friendlyPaymentMethod.toLowerCase() === 'stripe') {
    this.hasStripecontributions  = true;
    return; 
  }
  if (contribution.isPayEngine) {
    this.hasPayEngineContributions  = true;
    return; 
  }
});

// Now you can use the hasStripeContribution variable as needed
console.log(this.hasStripecontributions);
                this.pendingContributions = this._registryFirebaseService.getContributionsbyStatus(this.contributions, 'pending');
                this.cancelledContributions = this._registryFirebaseService.getContributionsbyStatus(this.contributions, 'cancelled');

                this.cancelledContributions.forEach(contribution => {
                  if (contribution.cancelReason == 'changedMind') {
                  contribution.cancelReason = 'Changed my mind';
                  } else if (contribution.cancelReason = 'mistake') {
                    contribution.cancelReason = 'Made a mistake';
                  }
                });

              this.loaded = true;
              this.parseContributionPaymentMehtodTotals(this.contributions)
              this.totalContributions = this.paidContributions.reduce(function (prevVal, elem) {
                return prevVal + elem.giftTotal;
              }, 0);


              this.todaysContributions = this.paidContributions
                .filter(x => new Date(x.createdDate).toDateString() === new Date().toDateString())
                .reduce(function (prevVal, elem) {
                  return prevVal + elem.giftTotal;
                }, 0);

            }
          });

          this._registryFirebaseService.currentRegistry.subscribe(registry => {
            if (registry) {
              this.registry = registry;

              
              this.contributionLimit = this._registryFirebaseService.getContributionLimit(this.registry);
              this.symbol = registry.symbol;
            }

          });

        }
      });
    });

  }

  setDemoMode(){
    this.payouts= [
      {
          "id": "po_1OLrJSQagr44ELi9FoKvOiGB",
          "object": "payout",
          "amount": 441981,
          "arrival_date": 1702252800,
          "automatic": true,
          "balance_transaction": "txn_1OLrJTQagr44ELi9muRo68o4",
          "created": 1702231270,
          "currency": "aud",
          "description": "STRIPE PAYOUT",
          "destination": "ba_1O7zREQagr44ELi9sAcUfQhx",
          "failure_balance_transaction": null,
          "failure_code": null,
          "failure_message": null,
          "livemode": false,
          "metadata": {},
          "method": "standard",
          "original_payout": null,
          "reconciliation_status": "completed",
          "reversed_by": null,
          "source_type": "card",
          "statement_descriptor": null,
          "status": "paid",
          "type": "bank_account"
      },
      {
          "id": "po_1OAcWwQagr44ELi9f3p0bogU",
          "object": "payout",
          "amount": 10000,
          "arrival_date": 1699574400,
          "automatic": true,
          "balance_transaction": "txn_1OAcWxQagr44ELi9wcTB4fEK",
          "created": 1699552838,
          "currency": "aud",
          "description": "STRIPE PAYOUT",
          "destination": "ba_1O7zREQagr44ELi9sAcUfQhx",
          "failure_balance_transaction": null,
          "failure_code": null,
          "failure_message": null,
          "livemode": false,
          "metadata": {},
          "method": "standard",
          "original_payout": null,
          "reconciliation_status": "completed",
          "reversed_by": null,
          "source_type": "card",
          "statement_descriptor": null,
          "status": "paid",
          "type": "bank_account"
      },
      {
          "id": "po_1OAG3VQagr44ELi9f7KlG1mg",
          "object": "payout",
          "amount": 29814,
          "arrival_date": 1699488000,
          "automatic": true,
          "balance_transaction": "txn_1OAG3WQagr44ELi9qLcIvqoi",
          "created": 1699466445,
          "currency": "aud",
          "description": "STRIPE PAYOUT",
          "destination": "ba_1O7zREQagr44ELi9sAcUfQhx",
          "failure_balance_transaction": null,
          "failure_code": null,
          "failure_message": null,
          "livemode": false,
          "metadata": {},
          "method": "standard",
          "original_payout": null,
          "reconciliation_status": "completed",
          "reversed_by": null,
          "source_type": "card",
          "statement_descriptor": null,
          "status": "paid",
          "type": "bank_account"
      }
  ]


  this.balance = {
      "object": "balance",
      "available": [
          {
              "amount": 411,
              "currency": "aud",
              "source_types": {
                  "card": 4119
              }
          }
      ],
      "livemode": false,
      "pending": [
          {
              "amount": 0,
              "currency": "aud",
              "source_types": {
                  "card": 0
              }
          }
      ]
  }

  }

  demoMode(){
    this.contributions.concat( this.demoContributions);
    this.paidContributions = this._registryFirebaseService.getContributionsbyStatus(this.contributions, 'paid');
    this.devMode='demo';
  }

  parseContributionPaymentMehtodTotals(contributions: Contribution[ ]) {
    
    this.contributionCount.paypal =0;  
    this.contributionCount.cash =0;
    this.contributionCount.cheque =0;
    this.contributionCount.venmo =0;
    this.contributionCount.bank =0;
    this.contributionCount.revolut =0;
    this.contributionCount.custom =0;
    this.contributionCount.cashApp =0;
    this.contributionCount.bitcoin =0;
    this.contributionCount.stripe =0;
    this.contributionCount.zelle = 0;
    this.contributionCount.wise = 0;
    this.contributionCount.payId = 0;
        contributions.forEach(contribution => {

      if(!contribution.friendlyPaymentMethod){
return;
      }
    switch(contribution.friendlyPaymentMethod.toLowerCase()){

      case 'paypal' :{
        this.contributionCount.paypal = this.contributionCount.paypal +1;
        break;
      }
      case 'pay id / e-transfer' :{
        this.contributionCount.payId = this.contributionCount.payId +1;
        break;
      }

      case 'wise' :{
        this.contributionCount.wise = this.contributionCount.wise +1;
        break;
      }


      case 'cash' :{
        this.contributionCount.cash = this.contributionCount.cash +1;
        break;
      }

      case 'cheque' :{
        this.contributionCount.cheque = this.contributionCount.cheque +1;
        break;
      }

      case 'venmo' :{
        this.contributionCount.venmo = this.contributionCount.venmo +1;
        break;
      }

      case 'bank transfer' :{
      this.contributionCount.bank = this.contributionCount.bank +1;
      break;
      }

      case 'revolut' :{
        this.contributionCount.revolut = this.contributionCount.revolut +1;
        break;
      }

      case 'cashApp' :{       
        this.contributionCount.cashApp= this.contributionCount.cashApp +1;
        break;
      }

      case 'bitcoin' :{
        this.contributionCount.bitcoin = this.contributionCount.bitcoin +1;
        break;
      }
      case 'stripe' :{
        this.contributionCount.stripe = this.contributionCount.stripe +1;
        break;
      }
      case 'custom' :{
        this.contributionCount.custom = this.contributionCount.custom +1;
        break;
      }
      case 'zelle' :{
        this.contributionCount.zelle = this.contributionCount.zelle +1;
        break;
      }

      

    }
        
      });
  }


  selectFirstName(fullName: string) {

    if (fullName) {
      return fullName.split(' ')[0];
    }
  }

  getGiftUrlWithoutHex(imageUrl: string) {
    if (imageUrl) {
      return this._registryService.cleanImageUrlRemoveHex(imageUrl);
    }
  }

  color(imageUrl: string) {
    return this._registryService.getColor(imageUrl);
  }

  exportCSV(){
    // JSON data
let jsonData = [];

this.contributions.forEach(contribution => {
  jsonData.push({
    "Gift Name": contribution.cart[0].gift.title,
    "Contribution": this.symbol+ " "+ contribution.giftTotal + " "+ this.registry.currency,
    "Payment Method": contribution.friendlyPaymentMethod,
    
    "Guest Name": contribution.guestName + (contribution.wish.partnersName ? " & " + contribution.wish.partnersName : ""),
    "Guest Message": contribution.wish.wishText.replace(/(\r\n|\n|\r)/gm, " ").replace('"' ,"'" )
  })
});


// Function to convert JSON to CSV
const jsonToCsv = (jsonData) => {
  // Extract the headers (keys) from the first object in the JSON array
  const headers = Object.keys(jsonData[0]);

  // Create the header row in the CSV file
  let csv = headers.join(",") + "\n";
jsonData.forEach(data => {
  // Extract the values for each header
  const values = headers.map(header => {
    let value = data[header];
    // Convert the value to a string
    value = value === null || value === undefined ? '' : String(value);
    // Replace double quotes with two double quotes
    value = value.replace(/"/g, '"');
    // If the value contains a comma, a newline, or a hash, surround it with double quotes
    if (value.includes(",") || value.includes("\n") || value.includes("#")) {
      return `"${value}"`;
    } else {
      return `"${value}"`;
    }
  });

  // Add the values to the CSV as a new row
  csv += values.join(",") + "\n";
});

  return csv;
};

// Convert JSON to CSV
const csvData = jsonToCsv(jsonData);

// Download CSV file
const downloadLink = document.createElement("a");
downloadLink.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csvData);
downloadLink.download = "Hitchd contributions export.csv";
downloadLink.click();



  }
  openMobileMenu() {
    this._userService.emitUpdateHeaderType('showMobileMenu');
  }
  private async updateTransferLimits() {
    const user = await this._authService.user.pipe(take(1)).toPromise();
    if (user) {
      const merchant = await this.merchantStateStore.getMerchant(user.uid)
        .pipe(take(1))
        .toPromise();
      
      if (merchant) {
        this.maxTransfersOverride = merchant.maxTransfersOverride || null;
        this.transfers = await this.merchantStateStore.getTransfers(user.uid);
                // Calculate remaining transfers
        if (this.maxTransfersOverride !== null) {
          this.remainingTransfers = this.maxTransfersOverride - this.transfers.length;
        } else {
          this.remainingTransfers = 3 - this.transfers.length;
        }
      }
    }
  }

  private setBodyScroll(disable: boolean) {
    document.body.style.overflow = disable ? 'hidden' : 'auto';
  }

  openBankDetailsModal() {
    this.showBankDetailsModal = true;
    this.setBodyScroll(true);
  }

  closeBankDetailsModal() {
    this.showBankDetailsModal = false;
    this.setBodyScroll(false);
  }

  openTransferModal() {
    this.showTransferModal = true;
    this.setBodyScroll(true);
  }

  closeTransferModal() {
    this.showTransferModal = false;
    this.setBodyScroll(false);
  }

  async ngOnInit() {
    const pageUserMode = this._route.snapshot.data.pageUserMode;
    this.settings = this._route.snapshot.data.settings;
    
    if (pageUserMode == 'couple_anon') {
      this.anonymousCoupleMode = true;
      this.loaded = true;
      this.registry = this._registryFirebaseService.getAnonRegistry();
      this.contributions = new Array<Contribution>();
      this.paidContributions = new Array<Contribution>();
      this.pendingContributions = new Array<Contribution>();
      this._registryFirebaseService.killLoader();
      this.symbol = this.registry.symbol;
    }
    const idToken: string = await this._authService.authToken().pipe(take(1)).toPromise();

    if(this.settings && this.settings.merchantId){
      // Get balance with maxOverride
      this._paymentService.GetPayEngineBalance(idToken).subscribe(response => {
        let responseData = response.json();
        console.log(responseData);
        
        if (responseData && responseData.data && Array.isArray(responseData.data)) {
          const currentCurrencyBalance = responseData.data.find(x => 
            x.currency.toUpperCase() === this.registry.currency.toUpperCase()
          );
          
          this.payengineBalance = {
            available: currentCurrencyBalance && currentCurrencyBalance.available_balance !== null && currentCurrencyBalance.available_balance !== undefined 
              ? Number(currentCurrencyBalance.available_balance) 
              : 0,
            pending: currentCurrencyBalance && currentCurrencyBalance.pending_balance !== null && currentCurrencyBalance.pending_balance !== undefined
              ? Number(currentCurrencyBalance.pending_balance)
              : 0
          };

          // Get remaining transfers from maxOverride if available
          if (responseData.maxOverride !== undefined && responseData.maxOverride !== null) {
            this.remainingTransfers = responseData.maxOverride;
          }
        }
      });

      // Fetch balance history from PayEngine
      this.payengineTransfersLoading = true;
      this._paymentService.GetBalanceHistory(idToken).subscribe(response => {
        let responseData = response.json();
        console.log('Balance history:', responseData);
        
        // Map PayEngine balance history to format compatible with existing UI
        if (responseData && responseData.data && Array.isArray(responseData.data)) {
          // Filter transactions for the current currency
          const filteredTransactions = responseData.data.filter(transaction => 
            transaction.currency.toUpperCase() === this.registry.currency.toUpperCase()
          );
          
          // Map to format similar to payouts

          
        }
        
        this.payengineTransfersLoading = false;
      }, error => {
        console.error('Error fetching balance history:', error);
        this.payengineTransfersLoading = false;
      });

      // Update transfer limits
      await this.updateTransferLimits();
    }
  }

  /**
   * Initiates a transfer of the available balance to the merchant's bank account
   */
  initiateTransfer() {
    if (this.remainingTransfers <= 0) {
      return;
    }

    this.loading = true;
    this._authService.authToken()
      .pipe(
        filter(token => token !== null),
        take(1),
        takeUntil(this.destroy$)
      )
      .subscribe(token => {
        if (token) {
          this._paymentService.CreateTransfer(token)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
              async response => {
                if (response.status === 200) {
                  const data = response.json();
                  
                  // Update merchant record with new transfer
                  const user = await this._authService.user.pipe(take(1)).toPromise();
                  if (user) {
                    // Update transfer limits after successful transfer
                    await this.updateTransferLimits();
                  }
                  
                  // Refresh balance after successful transfer
                  this._paymentService.GetPayEngineBalance(token)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe(balanceResponse => {
                      const balanceData = balanceResponse.json();
                      if (balanceData && balanceData.data && Array.isArray(balanceData.data)) {
                        const currentCurrencyBalance = balanceData.data.find(x => 
                          x.currency.toUpperCase() === this.registry.currency.toUpperCase()
                        );
                        
                        this.payengineBalance = {
                          available: currentCurrencyBalance && currentCurrencyBalance.available_balance !== null && currentCurrencyBalance.available_balance !== undefined 
                            ? Number(currentCurrencyBalance.available_balance) 
                            : 0,
                          pending: currentCurrencyBalance && currentCurrencyBalance.pending_balance !== null && currentCurrencyBalance.pending_balance !== undefined
                            ? Number(currentCurrencyBalance.pending_balance)
                            : 0
                        };
                      }
                      this.loading = false;
                      this.closeTransferModal();
                    });
                } else {
                  console.error('Error initiating transfer:', response);
                  this.loading = false;
                }
              },
              error => {
                console.error('Error initiating transfer:', error);
                this.loading = false;
              }
            );
        }
      });
  }

  ngOnDestroy() {
    // Ensure body scroll is restored when component is destroyed
    this.setBodyScroll(false);
    this.destroy$.next();
    this.destroy$.complete();
  }

  getStandardImageUrl(imageUrl: string): string {
    return this.imageUrlService.getStandardImageUrl(imageUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/track/track.component.ts